import React from 'react';
import { Col, Row } from 'react-bootstrap';
import '../../../assets/styles/components/AuthForm.css';
import RecaptchaV2 from '../Captcha/RecaptchaV2';
import { REACT_APP_RECAPTCHA_V2_SITE_KEY } from '../Routes/URLs';

const AuthRecaptcha = ({ show, verified, onVerify }) => {
  if (!show || !REACT_APP_RECAPTCHA_V2_SITE_KEY) return null;

  return (
    <Row className="auth-recaptcha g-0">
      <Col xs={12} sm={12} md={12} lg={12} className="d-flex justify-content-center">
        <Row id="recaptcha-v2-container" className={`auth-recaptcha-widget g-0${verified ? '' : ' has-error'}`}>
          <Col xs={12}>
            <RecaptchaV2 onVerify={onVerify} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AuthRecaptcha;
